module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAGZJREFUSEtjZKAxYKSx+Qz0tWD//v3/8fnI0dER7CBi1YHUoviAWI3Eqhu1AGd0weJq8AYRKXmHrFREcwsGbzIl1utk+4DmFhDrMmLVDd58MOoDgoUY2UFEbDIlRR1962RSXEasWgCNGoAZtGEfgQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/statistics.png
// module id = eyG/
// module chunks = 1